import {Component, computed, input, signal, Signal} from '@angular/core';
import {MatCard, MatCardContent, MatCardTitle} from '@angular/material/card';
import {County} from '../../../core/classes/county';
import {MatTab, MatTabGroup} from '@angular/material/tabs';
import {NgTemplateOutlet} from '@angular/common';

@Component({
  selector: 'tgrid-county-src-popup',
  imports: [
    MatCard,
    MatCardContent,
    MatCardTitle,
    MatTabGroup,
    MatTab,
    NgTemplateOutlet,
  ],
  templateUrl: './county-src-popup.component.html',
  styleUrl: './county-src-popup.component.scss',
})
export class CountySrcPopupComponent {
  public data = input.required<County>();

  protected title = computed(() => {
    if (this.data() === undefined) return '';
    return `Resiliency Curves for ${this.data().name} (${this.data().stateAbbreviation})`;
  });

  protected normalizedUrl: Signal<string> = computed(() => {
    return `api/metrics/src-image/${this.data().geoid}/normalized`;
  });

  protected nonNormalizedUrl: Signal<string> = computed(() => {
    return `api/metrics/src-image/${this.data().geoid}/nonnormalized`;
  });
  protected readonly nonNormalizedImageError = signal<boolean>(false);
  protected readonly normalizedImageError = signal<boolean>(false);


  constructor() {

  }
}
